import {Injectable} from '@angular/core';
import {
  AuthHttpHeaderService,
  AuthRedirectService,
  AuthStorageService,
  GlobalMessageService,
  OAuthLibWrapperService,
  RoutingService
} from '@spartacus/core';
import {HttpRequest} from '@angular/common/http';
import moment from 'moment';
import {ConfigService, DcpOccEndpointsService} from '@dcp/configurator';
import {DcpAuthService} from '@app/auth/services/dcp-auth.service';

@Injectable({
  providedIn: 'root'
})
export class DcpAuthHttpHeaderService extends AuthHttpHeaderService {

  constructor(
    protected authService: DcpAuthService,
    authStorageService: AuthStorageService,
    oAuthLibWrapperService: OAuthLibWrapperService,
    routingService: RoutingService,
    occEndpoints: DcpOccEndpointsService,
    globalMessageService: GlobalMessageService,
    authRedirectService: AuthRedirectService,
    private configService: ConfigService
  ) {
    super(authService, authStorageService, oAuthLibWrapperService, routingService, occEndpoints, globalMessageService, authRedirectService);
  }

  /**
   * Adds `Authorization` header for OCC calls and Kyma calls.
   */
  public alterRequest(request: HttpRequest<any>): HttpRequest<any> {
    const hasAuthorizationHeader = !!this.getAuthorizationHeader(request);
    const isBaseSitesRequest = this.isBaseSitesRequest(request);
    const isOccUrl = this.isOccUrl(request.url);
    const isKymaUrl = this.configService.isKymaUrl(request.url);
    if (!hasAuthorizationHeader && (isOccUrl || isKymaUrl) && !isBaseSitesRequest) {
      return request.clone({
        setHeaders: {
          ...this.createAuthorizationHeader(),
          'transaction-time': moment().format()
        },
      });
    }
    return request;
  }

  public handleExpiredRefreshToken(): void {
    this.authService.coreLogout().then(() => {
      this.authService.login();
    });
  }

  protected isOccUrl(url: string): boolean {
    if (typeof url !== 'string') {
      throw new TypeError(`Expected a string for 'url', but got ${typeof url}`);
    }
    const baseUrl = this.occEndpoints.getBaseUrl();
    return url?.includes(baseUrl);
  }
}
